import React from 'react';
import { formatPhone } from '../utils/formatPhone';

interface SummaryViewProps {
  cart: any[];
  customer: any;
  deliveryOption: string;
  deliveryCost: number;
  paymentStatus: string;
  paymentMethod?: string;
  saleType?: 'Venta' | 'Muestra';
  onBack: () => void;
  onConfirmOrder: () => void;
  onRemoveItem?: (id: number) => void;
}

function SummaryView({ cart, customer, deliveryOption, deliveryCost, paymentStatus, paymentMethod, saleType = 'Venta', onBack, onConfirmOrder, onRemoveItem }: SummaryViewProps) {
  const isSample = saleType === 'Muestra';
  const subtotal = isSample ? 0 : cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const total = subtotal + deliveryCost;
  const businessCost = cart.reduce((sum, item) => sum + (item.cost * item.quantity), 0);

  return (
    <div className="summary-view">
      <div className="summary-header">
        <button className="btn-secondary" onClick={onBack}>
          ← Atrás
        </button>
        <h1>Resumen del Pedido</h1>
        {isSample && <span className="badge-sample">🎁 Muestra Gratis</span>}
      </div>

      <div className="summary-content">
        <div className="summary-section">
          <h3>Cliente</h3>
          <div className="summary-customer">
            <p><strong>{customer.name}</strong></p>
            <p>{customer.email}</p>
            <p>{formatPhone(customer.phone)}</p>
          </div>
        </div>

        <div className="summary-section">
          <h3>Productos</h3>
          <div className="summary-products">
            {cart.map(item => (
              <div key={item.id} className="summary-product">
                <div className="summary-product-info">
                  <span className="summary-product-name">{item.name}</span>
                  <span className="summary-product-quantity">x{item.quantity}</span>
                </div>
                {isSample ? (
                  <span className="summary-product-price">
                    <span className="summary-product-price--struck">${(item.price * item.quantity).toFixed(2)}</span>
                    <span className="summary-product-price--free">GRATIS</span>
                  </span>
                ) : (
                  <span className="summary-product-price">
                    ${(item.price * item.quantity).toFixed(2)}
                  </span>
                )}
                {onRemoveItem && (
                  <button
                    className="remove-btn"
                    title="Eliminar del carrito"
                    onClick={() => onRemoveItem(item.id)}
                  >
                    🗑️
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="summary-section">
          <h3>Entrega y Pago</h3>
          <div className="summary-delivery">
            <p><strong>{deliveryOption}</strong></p>
            <p>
              {deliveryOption === 'En el lugar' 
                ? 'Entregar y pagar al momento' 
                : deliveryOption === 'Entrega' 
                  ? 'Entrega a domicilio en 24-48 horas' 
                  : 'Entrega en fecha y hora específica'
              }
            </p>
          </div>
          
          <div className="summary-payment">
            <p><strong>Estado de pago: {isSample ? 'Muestra' : paymentStatus}</strong></p>
            <p>
              {isSample
                ? 'Muestra gratis para el cliente'
                : paymentStatus === 'Pagado'
                  ? 'El cliente ya realizó el pago'
                  : 'Pendiente de pago'
              }
            </p>
            {!isSample && paymentMethod && (
              <p><strong>Método de pago:</strong> {paymentMethod}</p>
            )}
          </div>
        </div>

        <div className="summary-totals">
          <div className="summary-total-row">
            <span>Subtotal:</span>
            <span>${subtotal.toFixed(2)}</span>
          </div>
          <div className="summary-total-row">
            <span>Costo de entrega:</span>
            <span>${deliveryCost.toFixed(2)}</span>
          </div>
          <div className="summary-total-row total">
            <span>Total:</span>
            <span>${total.toFixed(2)}</span>
          </div>
          {isSample && (
            <div className="summary-total-row summary-total-row--cost">
              <span>Costo para el negocio:</span>
              <span>${businessCost.toFixed(2)}</span>
            </div>
          )}
        </div>
      </div>

      <div className="summary-actions">
        <button className="btn-primary" onClick={onConfirmOrder} disabled={cart.length === 0}>
          {isSample ? 'Confirmar Muestra' : 'Confirmar Pedido'}
        </button>
      </div>
    </div>
  );
}

export default SummaryView; 